import { render, staticRenderFns } from "./CheckRelation.vue?vue&type=template&id=f7ef158e&scoped=true"
import script from "./CheckRelation.vue?vue&type=script&lang=js"
export * from "./CheckRelation.vue?vue&type=script&lang=js"
import style0 from "./CheckRelation.vue?vue&type=style&index=0&id=f7ef158e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ef158e",
  null
  
)

export default component.exports